// components/KafkaMessageModal.jsx
import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Table, Badge, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import moment from 'moment';

const KafkaMessageModal = ({ isOpen, toggle, messageData }) => {
  const [activeTab, setActiveTab] = useState('message'); // ✅ Move hook to the top

  if (!messageData) return null; // ✅ Now safe to return early

  const parseMessageValue = (value) => {
    try {
      return value ? JSON.parse(value) : {};
    } catch (e) {
      console.error("Error parsing message value:", e);
      return { error: "Failed to parse message value" };
    }
  };

  const parsedValue = parseMessageValue(messageData.value);

  const formatValue = (value) => {
    if (value === null || value === undefined) return 'null';
    if (typeof value === 'object') {
      return (
        <pre className="mb-0 p-2 bg-light rounded" style={{ 
          whiteSpace: 'pre-wrap', 
          maxHeight: '200px', 
          overflow: 'auto',
          fontSize: '0.8rem'
        }}>
          {JSON.stringify(value, null, 2)}
        </pre>
      );
    }
    return String(value);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" className="kafka-message-modal">
      <ModalHeader toggle={toggle} className="py-2">
        <span>Detalles del Mensaje</span>
        <Badge color="info" className="ml-2">
          {messageData.topic}
        </Badge>
      </ModalHeader>
      
      <ModalBody className="p-0">
        <Nav tabs className="px-3 pt-2">
          <NavItem>
            <NavLink
              active={activeTab === 'message'}
              onClick={() => setActiveTab('message')}
              className="py-1 px-2"
            >
              Contenido
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              active={activeTab === 'metadata'}
              onClick={() => setActiveTab('metadata')}
              className="py-1 px-2"
            >
              Metadatos
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab} className="border-0">
          <TabPane tabId="message" className="p-3">
            <Table bordered size="sm" className="mb-0 table-striped">
              <tbody>
                {Object.entries(parsedValue).map(([key, value]) => (
                  <tr key={key}>
                    <th width="30%" className="py-2 px-2 align-top">{key}</th>
                    <td className="py-2 px-2 align-top">{formatValue(value)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TabPane>

          <TabPane tabId="metadata" className="p-3">
            <Table bordered size="sm" className="mb-0 table-striped">
              <tbody>
                <tr>
                  <th width="30%" className="py-2 px-2">Partition</th>
                  <td className="py-2 px-2">{messageData.partition}</td>
                </tr>
                <tr>
                  <th className="py-2 px-2">Offset</th>
                  <td className="py-2 px-2">{messageData.offset}</td>
                </tr>
                <tr>
                  <th className="py-2 px-2">Timestamp</th>
                  <td className="py-2 px-2">{moment(parseInt(messageData.timestamp)).format('YYYY-MM-DD HH:mm:ss')}</td>
                </tr>
                <tr>
                  <th className="py-2 px-2">Key</th>
                  <td className="py-2 px-2">{messageData.key || 'null'}</td>
                </tr>
              </tbody>
            </Table>
          </TabPane>
        </TabContent>
      </ModalBody>
    </Modal>
  );
};

export default KafkaMessageModal;